export const heroStats = [
  { value: '4 幕', label: '短剧主线结构' },
  { value: '6 位', label: '核心人物关系' },
  { value: '5 处', label: '未删减关键细节' },
  { value: '8 部', label: '同类题材参考' },
];

export const overviewPoints = [
  {
    icon: 'ri-route-line',
    title: '完整版剧情脉络',
    desc: '按幕次梳理短剧与小说的主线走向，标出关键转折与情感爆发点，让你在正式观看前先建立清晰的故事框架。',
  },
  {
    icon: 'ri-scissors-cut-line',
    title: '未删减细节详解',
    desc: '汇总常被剪辑掉的情绪铺垫、台词与人物动机，逐条说明这些内容如何推动后续剧情与结局的形成。',
  },
  {
    icon: 'ri-group-line',
    title: '人物关系梳理',
    desc: '拆解每位核心人物的身份、立场与情感纠葛，理清谁在主导关系、谁在被动应对，以及冲突的真正来源。',
  },
  {
    icon: 'ri-bookmark-3-line',
    title: '同类作品推荐',
    desc: '从主题、人物结构、叙事节奏三个维度出发，整理风格相近的伦理题材剧集与读物，方便顺着口味继续追。',
  },
];

export const plotShort = [
  {
    no: '第一幕',
    title: '初入家门',
    summary: '家庭结构重组后的磨合期，新成员的关系从客气走向微妙。',
    detail: '故事从一次看似平静的家庭聚餐开始，人物之间的称呼、座位与话题选择都暗藏分寸感。继母试图以温和得体的方式融入这个家庭，而继子则用疏离与试探回应。这一幕主要负责建立人物立场：谁在维持表面和谐，谁又在心里设下防线。',
    tags: ['人物立位', '氛围铺垫'],
  },
  {
    no: '第二幕',
    title: '界限动摇',
    summary: '日常相处增多，原本清晰的关系边界开始出现松动。',
    detail: '随着共同生活的时间拉长，一些原本被刻意回避的话题被反复触及。继母的关心逐渐超出礼貌的范畴，继子的抗拒也掺杂了依赖。剧情用大量生活化场景推进，让观众在细节里感受关系的偏移，而不是依靠台词的直接说明。',
    tags: ['关系推进', '细节叙事'],
  },
  {
    no: '第三幕',
    title: '真相浮现',
    summary: '被掩藏的往事与误解浮出水面，冲突从内部转向公开。',
    detail: '一个被反复提及却从未正面交代的过往成为转折点，父亲、生母与继母之间当年的选择被重新讨论。此前埋下的细节线索在此集中回收，人物的动机也从模糊变得具体。真正的矛盾不再是两个人的拉扯，而是整个家庭对旧事的回避。',
    tags: ['转折爆发', '线索回收'],
  },
  {
    no: '第四幕',
    title: '抉择与收束',
    summary: '每个人都要为关系重新划界，结局留下开放式的余味。',
    detail: '在经历冲突与摊牌之后，人物依次做出自己的选择：有人选择离开，有人选择留下承担，也有人选择把真相说出口。结尾没有给出过于明确的道德判断，而是把关系的走向交还给时间与观众，留有讨论空间。',
    tags: ['结局解读', '开放留白'],
  },
];

export const plotNovel = [
  {
    no: '序章',
    title: '视角与氛围',
    summary: '以第一人称视角进入家庭内部，先声夺人地建立压抑感。',
    detail: '小说开篇用大量环境描写与内心独白定调，读者比剧中人物更早察觉气氛的异常。叙述者在观察与自省之间反复摇摆，为后续的身份错位与情感纠葛埋下伏笔。',
    tags: ['视角铺垫', '心理描写'],
  },
  {
    no: '上卷',
    title: '关系推进',
    summary: '日常相处的细节被放大，情感的流动在字里行间缓慢累积。',
    detail: '相较短剧，小说用更多篇幅描写生活场景与内心变化，人物之间的试探被写得更细密。读者能读到角色没有说出口的想法，也因此更容易理解他们在关键选择时的犹豫。',
    tags: ['细节铺陈', '情感累积'],
  },
  {
    no: '中卷',
    title: '冲突升级',
    summary: '误会与隐瞒集中爆发，家庭内部的平衡被彻底打破。',
    detail: '中卷节奏明显加快，多条支线交汇。旧事的真相、旁人的介入与人物自身的挣扎同时推进，矛盾不再局限于两人之间，而是扩散到整个家庭网络。',
    tags: ['多线交汇', '节奏加快'],
  },
  {
    no: '下卷',
    title: '收束与留白',
    summary: '各条线索依次收拢，结尾保留可供解读的空间。',
    detail: '小说在收尾时选择了克制的处理方式，没有强行给出圆满或悲剧的结论，而是让读者根据前文的细节自行判断人物的去向，这也成为讨论度较高的部分。',
    tags: ['线索收拢', '开放结局'],
  },
];

export const characters = [
  {
    name: '继母',
    role: '关系核心',
    tone: 'primary',
    desc: '以得体的姿态进入新的家庭，表面温和克制，实际对关系的走向有强烈的掌控欲。她的每一步都经过权衡，也因此让她的动机最难被简单定义。',
    relation: '与继子、父亲形成三角拉扯，是推动剧情的主要动力。',
  },
  {
    name: '继子',
    role: '情感变量',
    tone: 'accent',
    desc: '处在青春与成年之间，对外来者本能抵触，却又在长期相处中产生依赖。他的态度反复，恰恰是剧情最真实的部分。',
    relation: '与继母的边界博弈，是他成长线的主轴。',
  },
  {
    name: '父亲',
    role: '沉默的节点',
    tone: 'secondary',
    desc: '家庭的支柱，却常在关键问题上选择回避。他的沉默并非无辜，很多矛盾的根源都能追溯到他当年的决定。',
    relation: '连接继母、继子与生母三条线的关键人物。',
  },
  {
    name: '生母',
    role: '缺席的在场者',
    tone: 'primary',
    desc: '虽然很少正面出场，但她的存在感贯穿全剧。关于她的记忆与评价，是家庭成员之间反复回避又无法绕开的话题。',
    relation: '她的过往决定了家庭当下的结构与心结。',
  },
  {
    name: '同窗好友',
    role: '外部视角',
    tone: 'accent',
    desc: '站在家庭之外，用旁观的语气点出继子不愿承认的情绪。她既是倾诉对象，也是观众理解人物的一面镜子。',
    relation: '为继子提供情感出口与外部参照。',
  },
  {
    name: '知情人',
    role: '线索持有者',
    tone: 'secondary',
    desc: '掌握部分旧事真相，出场不多却次次关键。她的只言片语往往在后续剧情里被证明是重要伏笔。',
    relation: '在关键节点推动真相浮出水面。',
  },
];

export const uncutDetails = [
  {
    title: '被删减的情绪铺垫',
    content: '公开版本常省略人物独处时的沉默镜头，这些片段恰恰交代了角色内心的动摇过程。补上之后，后续的情感转折会显得更自然，而不是突然发生。',
  },
  {
    title: '关键台词的完整表述',
    content: '部分版本在处理重要对话时做了简化和消音，完整表述中的停顿与用词更能体现人物当时的真实态度，也直接影响观众对角色立场的判断。',
  },
  {
    title: '支线人物的出场作用',
    content: '同窗好友与知情人的戏份在剪辑版中容易被压缩，但他们的每一次出现都在补充主线信息。理解这些支线，才能看清真相是如何一步步被拼凑出来的。',
  },
  {
    title: '场景转换中的隐藏线索',
    content: '镜头在家庭不同空间之间的切换往往带有暗示：谁在场、谁缺席、物品的位置变化，都对应着人物关系的变化，适合回看时逐帧留意。',
  },
  {
    title: '结局的两种解读方式',
    content: '结尾的处理方式相对克制，既可以被理解为和解，也可以被理解为另一种形式的告别。不同解读对应着对人物动机的不同理解，这也是讨论度较高的一处。',
  },
];

export const highlights = [
  {
    icon: 'ri-mental-health-line',
    title: '心理博弈层层递进',
    desc: '剧情很少用直白台词点破关系，而是通过态度、措辞和沉默的差异，让观众自己感受两人之间的距离变化。',
  },
  {
    icon: 'ri-home-smile-2-line',
    title: '家庭氛围的压迫感',
    desc: '熟悉的居家场景被拍得恰到好处地紧绷，越是日常的相处，越能显出人物之间没有说出口的紧张。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '伏笔与反转密度高',
    desc: '前面看似随意的细节，往往在后续剧情里被重新提及。回看时能发现大量早已埋好的线索。',
  },
  {
    icon: 'ri-question-answer-line',
    title: '角色动机的模糊性',
    desc: '主要人物都没有绝对的好坏立场，同一句台词在不同观众那里会得到完全相反的理解，讨论空间很大。',
  },
  {
    icon: 'ri-movie-line',
    title: '视听语言克制有度',
    desc: '配乐与镜头以服务情绪为主，不过度渲染，反而让关键场景的情绪落点更稳、更耐看。',
  },
  {
    icon: 'ri-open-arm-line',
    title: '开放式结尾余味长',
    desc: '结局不替观众做判断，把人物关系交给时间去解答，追完之后仍会反复回想其中的选择。',
  },
];

export const recommendations = [
  {
    title: '《家门》',
    type: '家庭伦理剧集',
    meta: '现代都市 · 家庭重组',
    tags: ['家庭伦理', '关系重组'],
    similar: '同样以重组家庭为核心，用日常场景推进人物关系的微妙变化。',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%20of%20a%20quiet%20modern%20living%20room%20at%20dusk%2C%20warm%20crimson%20and%20amber%20light%20through%20sheer%20curtains%2C%20elegant%20moody%20color%20grading%2C%20soft%20film%20grain%2C%20empty%20armchair%20and%20family%20photo%20frame%2C%20editorial%20minimal%20composition%2C%20no%20people%2C%20subtle%20emotional%20tension&width=600&height=800&seq=rec-drama-01&orientation=portrait',
  },
  {
    title: '《旧事》',
    type: '悬疑伦理剧集',
    meta: '都市悬疑 · 往事揭秘',
    tags: ['悬疑', '真相'],
    similar: '围绕一段被掩埋的往事展开，靠线索回收完成情绪爆点，节奏与结构非常接近。',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%20of%20an%20old%20wooden%20desk%20with%20a%20sealed%20letter%20and%20a%20faded%20photograph%2C%20single%20warm%20lamp%20glow%20in%20a%20dark%20room%2C%20amber%20and%20deep%20brown%20tones%2C%20mysterious%20editorial%20mood%2C%20soft%20film%20grain%2C%20shallow%20depth%20of%20field%2C%20no%20people&width=600&height=800&seq=rec-drama-02&orientation=portrait',
  },
  {
    title: '《她的选择》',
    type: '女性成长剧集',
    meta: '都市情感 · 自我觉醒',
    tags: ['成长', '都市情感'],
    similar: '以女性角色的主动选择为主线，同样是先立关系再谈立场，人物弧光完整。',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%20of%20a%20woman%20silhouette%20standing%20by%20a%20tall%20window%20in%20warm%20golden%20backlight%2C%20modern%20apartment%20interior%2C%20elegant%20restrained%20color%20grading%20in%20amber%20and%20terracotta%2C%20soft%20film%20grain%2C%20artistic%20editorial%20mood%2C%20back%20view%20only&width=600&height=800&seq=rec-drama-03&orientation=portrait',
  },
  {
    title: '《长夜之后》',
    type: '复仇伦理题材',
    meta: '都市悬疑 · 隐忍反击',
    tags: ['复仇', '悬疑'],
    similar: '人物动机复杂、情绪张力强，擅长用克制的方式表现内心的暗流涌动。',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%20of%20rain%20on%20a%20city%20window%20pane%20at%20night%2C%20warm%20street%20lamp%20reflections%20in%20amber%20and%20crimson%2C%20lonely%20moody%20atmosphere%2C%20soft%20film%20grain%2C%20artistic%20editorial%20composition%2C%20dark%20but%20warm%20tones%2C%20no%20people&width=600&height=800&seq=rec-drama-04&orientation=portrait',
  },
  {
    title: '《归途》',
    type: '家庭剧情电影',
    meta: '文艺家庭 · 和解主题',
    tags: ['家庭伦理', '成长'],
    similar: '关于回家与重新理解家人，情绪落点温和，适合追完主剧后缓和心情。',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%20of%20an%20empty%20country%20road%20at%20golden%20sunset%2C%20warm%20amber%20sky%20and%20soft%20dust%20haze%2C%20distant%20small%20house%20silhouette%2C%20nostalgic%20editorial%20mood%2C%20soft%20film%20grain%2C%20minimal%20composition%2C%20no%20people&width=600&height=800&seq=rec-drama-05&orientation=portrait',
  },
  {
    title: '《相邻的房间》',
    type: '伦理题材小说',
    meta: '家庭文学 · 关系边界',
    tags: ['家庭伦理', '真相'],
    similar: '小说以细腻的心理描写见长，适合想深入人物内心的读者，节奏比剧集更慢。',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%20of%20two%20adjacent%20doors%20in%20a%20dim%20warm%20hallway%2C%20soft%20amber%20light%20spilling%20from%20one%20room%2C%20deep%20brown%20and%20terracotta%20tones%2C%20quiet%20literary%20mood%2C%20soft%20film%20grain%2C%20editorial%20minimal%20composition%2C%20no%20people&width=600&height=800&seq=rec-drama-06&orientation=portrait',
  },
  {
    title: '《雨信》',
    type: '悬疑题材小说',
    meta: '心理悬疑 · 多重叙述',
    tags: ['悬疑', '复仇'],
    similar: '采用多视角叙述，靠信息差制造张力，读到中后段会有明显的反转体验。',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%20of%20rain%20droplets%20on%20an%20aged%20paper%20letter%20beside%20a%20warm%20desk%20lamp%2C%20amber%20glow%20in%20a%20dark%20study%20room%2C%20moody%20editorial%20atmosphere%2C%20soft%20film%20grain%2C%20shallow%20depth%20of%20field%2C%20deep%20crimson%20accents%2C%20no%20people&width=600&height=800&seq=rec-drama-07&orientation=portrait',
  },
  {
    title: '《第二次见面》',
    type: '都市情感短剧',
    meta: '短剧 · 关系拉扯',
    tags: ['都市情感', '复仇'],
    similar: '同为短剧形式，单集节奏快、钩子密集，很适合作为同类题材的下一部。',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%20of%20a%20warm%20city%20cafe%20table%20for%20two%2C%20two%20coffee%20cups%20under%20amber%20evening%20light%2C%20elegant%20moody%20editorial%20mood%2C%20soft%20film%20grain%2C%20terracotta%20and%20gold%20tones%2C%20minimal%20composition%2C%20no%20people&width=600&height=800&seq=rec-drama-08&orientation=portrait',
  },
];

export const recFilters = ['全部', '家庭伦理', '悬疑', '复仇', '成长', '都市情感'];

export const themes = [
  {
    icon: 'ri-divide-line',
    title: '边界与越界',
    desc: '故事真正讨论的并非某个人物，而是家庭成员之间那条看不见的边界，以及它被反复试探时的张力。',
  },
  {
    icon: 'ri-scales-3-line',
    title: '权力与依附',
    desc: '谁掌握话语权、谁需要依附他人生活，决定了关系里每一次让步与对抗的走向。',
  },
  {
    icon: 'ri-eye-off-line',
    title: '秘密与真相',
    desc: '被回避的旧事才是矛盾的根源。真相每揭开一层，人物的立场就会被重新审视。',
  },
  {
    icon: 'ri-heart-3-line',
    title: '救赎与代价',
    desc: '没有人能全身而退，每一次和解背后都有让步。结局留白，正是把评判交给观众。',
  },
];

export const faqs = [
  {
    q: '《继母的诱惑》完整版和未删减版有什么区别？',
    a: '通常所说的完整版侧重补齐剧情段落与场景衔接，而未删减版更强调保留情绪铺垫和对话细节。两者的主线一致，区别主要在于人物动机的完整度与部分关键场景的呈现方式。',
  },
  {
    q: '短剧版和小说版的剧情一致吗？',
    a: '核心主线与人物关系基本一致，但呈现方式差别较大。短剧受时长限制，节奏更快、钩子更密；小说则有更多心理描写与旁支铺垫，人物内心的变化会更连贯。',
  },
  {
    q: '故事的主要矛盾是什么？',
    a: '表面上是新家庭成员的相处问题，实质上是整个家庭对一段旧事的不同态度。矛盾的产生与激化，往往来自人物之间的回避与沉默，而不是单一事件。',
  },
  {
    q: '结局是开放式的吗？',
    a: '是的，结尾采用相对克制、留白的处理方式，没有替观众给出明确判断。这种结局也是该题材讨论度较高、被多次解读的原因之一。',
  },
  {
    q: '适合什么类型的观众观看？',
    a: '适合喜欢家庭伦理、人物关系分析与心理博弈的观众，也适合偏好慢热、看重细节与伏笔的读者。若偏好强情节、快节奏的类型，建议先从短剧版入手。',
  },
  {
    q: '想找类似作品应该从哪里看起？',
    a: '可以先参考本页下方的「类似伦理题材作品推荐」，按家庭伦理、悬疑、复仇等标签筛选；也可以从「核心主题解读」入手，按自己最感兴趣的主题方向挑选。',
  },
];

export const navLinks = [
  { id: 'intro', label: '本站导读' },
  { id: 'plot', label: '剧情脉络' },
  { id: 'characters', label: '人物关系' },
  { id: 'uncut', label: '未删减细节' },
  { id: 'recommend', label: '作品推荐' },
  { id: 'faq', label: '常见问题' },
];